<crm-multi-select
  [filtersUiVersion]="filtersUiVersion"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [label]="isFloatLabel ? 'Конвертер' : ''"
  [showClear]="showClear"
  [appendTo]="appendTo"
  [options]="converters"
  [disabled]="disabled"
  [display]="display"
  [sort]="sort"
  [placeholder]="placeholder"
  [(selectedItems)]="selectedConverters"
  (selectedItemsChange)="selectedConvertersChange.emit($event)"></crm-multi-select>
